import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import ButtonBase from '@mui/material/ButtonBase';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import { type MouseEvent, type ReactNode, useState } from 'react';

const MENU_ID = 'help-menu';

interface GuideButtonProps {
  onOpenGuide: () => void;
  onStartTour?: () => void;
}

export function GuideButton({ onOpenGuide, onStartTour }: GuideButtonProps): ReactNode {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const close = () => setAnchorEl(null);

  return (
    <>
      <Tooltip title={open ? '' : 'Guidebook and product tour'}>
        <ButtonBase
          onClick={(event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}
          aria-label="Help"
          aria-haspopup="menu"
          aria-expanded={open}
          aria-controls={open ? MENU_ID : undefined}
          sx={{
            height: 40,
            gap: 1,
            px: 3,
            fontSize: 13,
            fontWeight: 500,
            borderRadius: 1,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'border.strong',
            color: open ? 'text.primary' : 'text.secondary',
            transition: 'box-shadow .15s, color .15s',
            '&:hover': { color: 'text.primary', boxShadow: 4 },
          }}
        >
          <HelpOutlineOutlined sx={{ fontSize: 20 }} />
          Help
        </ButtonBase>
      </Tooltip>

      <Menu
        id={MENU_ID}
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: { sx: { mt: 1, minWidth: 180, boxShadow: 5 } },
          list: { sx: { p: 1 } },
        }}
      >
        <MenuItem
          onClick={() => {
            close();
            onOpenGuide();
          }}
          sx={{ borderRadius: 1, fontSize: 13 }}
        >
          Guidebook
        </MenuItem>
        {onStartTour ? (
          <MenuItem
            onClick={() => {
              close();
              onStartTour();
            }}
            sx={{ borderRadius: 1, fontSize: 13 }}
          >
            Product Tour
          </MenuItem>
        ) : null}
      </Menu>
    </>
  );
}
